import React, { useEffect } from 'react';
import { updateOnboardingHint } from 'api/account/updateOnboardingHint';
import { useCurrentUser } from 'contexts/CurrentUserContext';
import { useNavigate, useParams } from 'react-router-dom';

const LoginHint = () => {
  const { program } = useParams<{ program: string }>();
  const { state: userState } = useCurrentUser();
  const account = userState.account;
  const navigate = useNavigate();

  useEffect(() => {
    const updateHintAndRedirect = async () => {
      if (account && program) {
        try {
          const result = await updateOnboardingHint(program);
          if (result.success) {
            navigate('/home');
          } else {
            console.error('Failed to update onboarding hint:', result.errors);
            navigate('/home');
          }
        } catch (error) {
          console.error('Error updating onboarding hint:', error);
          navigate('/home');
        }
      } else {
        navigate('/home');
      }
    };

    updateHintAndRedirect();
  }, [account, program, navigate]);

  return <div>Loading...</div>;
};

export default LoginHint;
